import React from "react";
import { Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as alertActions from "../../redux/actions/alertAction";

import { myUtilities } from "../../Utils";

const AlertDialog = (props) => {
  return (
    <Modal
      show={props.alert.showAlert}
      onHide={props.alertActions.hideAlertAction}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {myUtilities.accountSpecificLanguage("Alert.Header", "Alert!" )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {myUtilities.accountSpecificLanguagePlaceholders(
              props.alert.id,
              props.alert.message,
              props.alert.value !== undefined ? props.alert.value : {}
        )}
        { props.alert.additionalItems && props.alert.additionalItems.length !== 0 && (
                <ul>
                  {props.alert.additionalItems.map((displayName) => (
                      <li>
                        {displayName}
                      </li>
                    )
                  )}
                </ul>
              )}
       </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={props.alertActions.hideAlertAction}
        >
        	{myUtilities.accountSpecificLanguage("AlertDialog.Ok", "Ok")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  alert: state.commonAlerts,
});

const mapDispatchToProps = (dispatch) => ({
  alertActions: bindActionCreators(alertActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);
